import { Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import Document from './accordions/document';
import HeadAccordion from './accordions/head-accordion';
import { FormikProps } from 'formik';
import { ViewStepVM } from 'civil-status/view-models/step-form';
import AttoAnnotationsAccordion from './accordions/atto-annotations-accordion';
import HolderAccordion from './accordions/holder';
import AnnotationsAccordion from './accordions/annotations-accordion';
import TextAct from '../shared/text-act';
import { CommunicationRes } from 'shell/models/communications';
import Comunication from './accordions/comunication';

interface ViewStepProps {
  formContext: FormikProps<ViewStepVM>;
  isCommunications?: boolean;
  controlsCommunications?: Array<CommunicationRes>;
  stateNotification?: string;
  onPreviewByIdAnsc?: (idAnsc: string) => void;
  idAnsc?: string;
}

const ViewStepComponent = ({
  formContext,
  isCommunications = false,
  controlsCommunications,
  stateNotification,
  idAnsc,
  onPreviewByIdAnsc,
}: ViewStepProps): React.ReactElement => {
  return (
    <Fragment>
      <Grid item xs={12}>
        <HeadAccordion stateNotification={stateNotification} />
      </Grid>
      {isCommunications ? (
        <Grid item xs={12}>
          <Comunication formContext={formContext} controlsCommunications={controlsCommunications} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          {(formContext.values?.holders || []).map((itemHolder, index) => (
            <HolderAccordion key={`${itemHolder.title}-${index}`} holder={itemHolder} />
          ))}
          <Document formContext={formContext} />
          <TextAct formContext={formContext} onlyRead />
          <AnnotationsAccordion formContext={formContext} />
          {onPreviewByIdAnsc ? (
            <AttoAnnotationsAccordion
              formContext={formContext}
              onPreviewByIdAnsc={onPreviewByIdAnsc}
              idAnscFromRoute={idAnsc}
            />
          ) : null}
        </Grid>
      )}
    </Fragment>
  );
};

ViewStepComponent.displayName = 'View Step Component';

const ViewStep = memo(ViewStepComponent);

export default ViewStep;
